const selectMasterGain = ({ masterGain }) => masterGain;

export default selectMasterGain;
